export default class TimeoutError extends Error {
	constructor() {
		super('Request has timed out.');
		Object.setPrototypeOf(this, TimeoutError.prototype);
	}
}
